import React from "react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  return (
    <div className="flex items-center justify-center space-x-2">
      <button
        className={`text-gray-700 hover:text-gray-900 ${currentPage === 1 ? "text-gray-400 cursor-not-allowed" : ""}`}
        aria-label="Previous page"
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
      >
        &lt;
      </button>

      {/* Show page numbers with a maximum of 5 pages */}
      {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
        const pageNum = currentPage > 3 ? (currentPage + i > totalPages ? totalPages - 4 + i : currentPage - 2 + i) : i + 1;

        if (pageNum <= totalPages) {
          return (
            <button
              key={pageNum}
              className={`w-8 h-8 rounded-full ${
                pageNum === currentPage ? "bg-amber-700 text-white" : "text-gray-700 hover:bg-gray-200"
              }`}
              onClick={() => onPageChange(pageNum)}
            >
              {pageNum}
            </button>
          );
        }
        return null;
      })}

      <button
        className={`text-gray-700 hover:text-gray-900 ${currentPage === totalPages ? "text-gray-400 cursor-not-allowed" : ""}`}
        aria-label="Next page"
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
      >
        &gt;
      </button>
    </div>
  );
}
